/**
 * antd `InputNumber`-ийн мянгатын таслын formatter/parser хос.
 *
 * Өмнө нь энэ хос үнийн талбар бүр дээр (product/Add, product/Edit,
 * product/ProductVersion, productGroup/Add) хуулагдаж бичигдсэн байсан бөгөөд
 * parser нь мянгатын таслаас гадна ТООНЫ БҮРЭЛДЭХҮҮН тэмдэгтийг ч хасдаг байв:
 *
 *     `${value}`.replace(/[^\d.-]/g, '')   // "1e5" → "15"
 *
 * Ингэснээр «1e5» гэж бичсэн хэрэглэгч ямар ч анхааруулгагүйгээр 15₮ үнэтэй
 * бараа хадгалдаг байсан. Parser нь зөвхөн ХАРАГДАХ ЗАСВАРЫГ (тасал, зай)
 * буцаан тайлах ёстой — утгыг тайлахыг InputNumber өөрөө хийнэ, буруу утгыг
 * `formRules`-ийн дүрмүүд ил алдаагаар барина.
 */

/** Мянгатын байрлалд тасал тавина (бутархай хэсгийг хөндөхгүй) */
export const formatThousands = (value) => {
  if (value === undefined || value === null || value === '') return '';

  const [whole, ...fraction] = `${value}`.split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return fraction.length ? `${grouped}.${fraction.join('.')}` : grouped;
};

/** `formatThousands`-ийн тавьсан тасал, зайг л хасна — өөр юуг ч хөндөхгүй */
export const parseThousands = (value) => {
  if (value === undefined || value === null) return '';

  return `${value}`.replace(/[\s,]/g, '');
};
